"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconSearch = function IconSearch(_ref) {
  var className = _ref.className,
      color = _ref.color;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    className: className
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.2536 19.2267C16.5526 19.2267 19.2269 16.5523 19.2269 13.2534C19.2269 9.95438 16.5526 7.28003 13.2536 7.28003C9.95462 7.28003 7.28027 9.95438 7.28027 13.2534C7.28027 16.5523 9.95462 19.2267 13.2536 19.2267Z",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.7206 20.72L17.4727 17.472",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

IconSearch.defaultProps = {
  color: 'black'
};
IconSearch.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconSearch;
exports.default = _default;